export const DEFAULT_RECENT_ACTIVITY_ITEM_LIMIT = 3;

export type Beneficiary = {
  name: string;
  globalId: string;
};

export enum CommitmentGiftStepsEnum {
  Prepare = 'Preparing',
  Sending = 'Sending',
  Delivered = 'Delivered',
}

export enum CommunicationDirectionEnum {
  B2S = 'Beneficiary To Supporter',
  S2B = 'Supporter To Beneficiary',
}

export enum CommunicationStatusEnum {
  Submitted = 'Submitted', // TODO: temporary status
  InTranslation = 'In Translation',
  Delivered = 'Complete Delivered',
}

export type Communication = {
  beneficiary: Beneficiary;
  direction: string;
  createdDate: string;
  readyForISLDate: string;
  sbcGlobalStatus: string;
  globalPartnerSBCId: string;
  isReadBySupporter: boolean;
};
